import { Component } from 'react';

// eslint-disable-next-line import/no-cycle
import { Modal } from 'common/components/layout';
import AddressListModal from 'profile/addressBook/ListModal';

class AddressBook extends Component {
  handleEditAddress = (id) => {
    const { props } = this;
    props.handleEditAddress(id);
  };

  handleAddAddress = (e) => {
    e.preventDefault();
    const { props } = this;
    props.handleAddAddress();
  };

  handlePickup = (e) => {
    e.preventDefault();
    const { props } = this;
    props.handlePickup();
  };

  render() {
    const { onCloseModal, onSelectAddress } = this.props;
    return (
      <Modal title="Ship To" onCloseModal={onCloseModal}>
        <p>
          <span className="c7-modal__pickup-option">
            <a onClick={this.handlePickup}>Pickup</a>
            &nbsp;&nbsp;|&nbsp;&nbsp;
          </span>
          <a onClick={this.handleAddAddress}>Add Address</a>
        </p>
        <AddressListModal
          onSelectAddress={onSelectAddress}
          onEditAddress={this.handleEditAddress}
        />
      </Modal>
    );
  }
}

export default AddressBook;
